import {
  ApartmentOutlined,
  CheckSquareOutlined,
  DashboardOutlined,
  FileTextOutlined,
  FolderOpenOutlined,
  ProfileOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { ROUTES } from '@/constants/routes';
import { BaseAppLayout } from '@/layouts/BaseAppLayout';

const menuItems: MenuProps['items'] = [
  {
    key: ROUTES.admin.dashboard,
    icon: <DashboardOutlined />,
    label: '工作台',
  },
  {
    key: ROUTES.admin.departments,
    icon: <ApartmentOutlined />,
    label: '组织架构',
  },
  {
    key: ROUTES.admin.users,
    icon: <TeamOutlined />,
    label: '用户管理',
  },
  {
    key: ROUTES.admin.tasks,
    icon: <CheckSquareOutlined />,
    label: '任务管理',
  },
  {
    key: ROUTES.admin.reports,
    icon: <FileTextOutlined />,
    label: '日报管理',
  },
  {
    key: ROUTES.admin.projectReports,
    icon: <ProfileOutlined />,
    label: '项目日报（兼容模式 Lite）',
  },
  {
    key: ROUTES.admin.projects,
    icon: <FolderOpenOutlined />,
    label: '项目管理',
  },
];

export function AdminLayout() {
  return <BaseAppLayout menuItems={menuItems} />;
}
